import { BOProduct, ImageType } from '@boels/models';

export const productCardMockData1: BOProduct = {
  name: 'good product',
  code: '12345',
  url: '/hire/excavator-08-t-conventional/p/12407',
  isNew: true,
  description: 'This is a short description of a good product',
  images: {
    PRIMARY: {
      product: {
        url: 'https://mediahub.boels.com/m/4485ebe72a3277fb/small-12410.jpg',
        altText: 'asd',
        format: 'product',
        imageType: ImageType.PRIMARY,
      },
    },
  },
};

export const productCardMockData2: BOProduct = {
  name: 'very very nice product',
  code: '12345',
  url: '/hire/excavator-08-t-conventional/p/12407',
  isNew: false,
  oneCall: 'true',
  images: {
    PRIMARY: {
      product: {
        url: 'https://mediahub.boels.com/m/4485ebe72a3277fb/small-12410.jpg',
        altText: 'asd',
        format: 'product',
        imageType: ImageType.PRIMARY,
      },
    },
  },
};

export const productCardMockData3: BOProduct = {
  name: 'not so nice product',
  code: '12345',
  url: '/hire/excavator-08-t-conventional/p/12407',
  isNew: true,
  oneCall: 'true',
  images: {
    PRIMARY: {
      product: {
        url: 'https://mediahub.boels.com/m/65fab9725b760a31/small-13597.jpg',
        altText: 'asd',
        format: 'product',
        imageType: ImageType.PRIMARY,
      },
    },
  },
};

export const productCardMockData4: BOProduct = {
  name: 'nice product',
  code: '12345',
  url: '/hire/excavator-08-t-conventional/p/12407',
  isNew: false,
  oneCall: 'false',
  images: {
    PRIMARY: {
      product: {
        url: 'https://mediahub.boels.com/m/74979c6cbaa5ada9/small-17374.jpg',
        altText: 'asd',
        format: 'product',
        imageType: ImageType.PRIMARY,
      },
    },
  },
};

export const productCardsMockData = [
  productCardMockData1,
  productCardMockData2,
  productCardMockData3,
  productCardMockData4,
];
